import {atom} from 'recoil';
import {recoilPersist} from 'recoil-persist'
import Const from "../constant/Const";

const {persistAtom} = recoilPersist()

export const defaultValue = {
    ua: "",
    browser: {},
    engine: {},
    os: {},
    device: {},
    cpu: {}
}

const agentAtom = atom({
    key: 'agent',
    default: defaultValue,
    effects_UNSTABLE: [persistAtom],
});

export const isMobilApp = () => {
    return true;
}

export const setMobilApp = (status) => {
    localStorage.setItem(Const.MOBIL_APP, status);
}

const isDeviceMobile = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/iPad/i.test(userAgent)) return true;
    if (/iPhone/i.test(userAgent)) return true;
    if (/iPod/i.test(userAgent)) return true;
    const isAndroid = /Android/i.test(userAgent);
    const isTablet = /Tablet|iPad/i.test(userAgent) || (isAndroid && !/Mobile/i.test(userAgent));
    if (isTablet) return true;
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    const isMac = navigator.platform === 'MacIntel';
    if (isIOS && isMac && window.screen.height <= 1024) return true;
    let type = JSON.parse(localStorage.getItem(Const.RECOIL_PERSIST) || null)?.agent?.device?.type || null;
    return type !== null && type === 'mobile';
}

export {agentAtom};
